/**
 * Marks product photos that are genuine cut-outs, so the "well" ground can stand them on a soft
 * floor shadow (snippets/card-gallery.liquid, v3 spec 1.2 and I16).
 *
 * It reads the photo's own top-left pixel: transparent there means a cut-out. Nothing about the
 * file's name or extension is trusted, because this catalogue's filenames name the wrong format
 * 62% of the time (brand guide, decision 13). A photo that cannot be read (cross-origin, not yet
 * decoded, a video poster) simply gets no shadow, which is the safe outcome.
 */
const SELECTOR = '.card-gallery--well .product-media-container img.product-media__image';
const canvas = document.createElement('canvas');
canvas.width = 1;
canvas.height = 1;
const context = canvas.getContext('2d', { willReadFrequently: true });

/** @param {HTMLImageElement} image */
function probe(image) {
  if (image.dataset.cutoutChecked) return;
  const container = image.closest('.product-media-container');
  if (!container || !context) return;

  const check = () => {
    image.dataset.cutoutChecked = 'true';
    try {
      context.clearRect(0, 0, 1, 1);
      context.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 1);
      const alpha = context.getImageData(0, 0, 1, 1).data[3];
      if (alpha !== undefined && alpha < 250) container.setAttribute('data-cutout', '');
    } catch {
      // Tainted canvas or undecodable image: leave it without a shadow.
    }
  };

  if (image.complete && image.naturalWidth > 0) check();
  else image.addEventListener('load', check, { once: true });
}

const scan = (/** @type {ParentNode} */ root) => root.querySelectorAll(SELECTOR).forEach((image) => {
  if (image instanceof HTMLImageElement) probe(image);
});

scan(document);
new MutationObserver((records) => {
  for (const record of records) {
    record.addedNodes.forEach((node) => {
      if (node instanceof Element) scan(node);
    });
  }
}).observe(document.body, { childList: true, subtree: true });
